module.exports = __webpack_public_path__ + "static/media/achievements-icon.beee4849.svg";